import { render, staticRenderFns } from "./VContentLoading.vue?vue&type=template&id=695763a0"
import script from "./VContentLoading.vue?vue&type=script&lang=ts"
export * from "./VContentLoading.vue?vue&type=script&lang=ts"
import style0 from "./VContentLoading.vue?vue&type=style&index=0&id=695763a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports